export enum LocalStorageKeysEnum {
  SustainabilityReportProjectBusinessArea = 'SustainabilityReportProjectBusinessArea',
  SustainabilityReportProjectTagsResponse = 'SustainabilityReportProjectTagsResponse',
  SustainabilityReportProjectProjectStatusFilter = 'SustainabilityReportProjectProjectStatusFilter',
  SustainabilityReportProjectYear = 'SustainabilityReportProjectYear',
  SustainabilityReportReportedByMe = 'SustainabilityReportReportedByMe',
}
